// Backlog 205: "A new version is ready" strip. Shown only between calls; the
// agent chooses when to refresh. Rules: lib/newVersion.js.
import React from 'react';
import { useContact } from '../context/ContactContext';
import { useNewVersion } from '../hooks/useNewVersion';
import { mayShowStrip, STRIP_TEXT } from '../lib/newVersion';

const strip = {
  display: 'flex', alignItems: 'center', gap: 16, padding: '10px 20px',
  background: 'rgba(94,214,190,0.12)', borderBottom: '1px solid rgba(94,214,190,0.45)',
  color: '#d8f5ee', fontSize: 14,
};
const button = {
  padding: '6px 14px', borderRadius: 8, border: '1px solid rgba(94,214,190,0.6)',
  background: 'rgba(94,214,190,0.14)', color: '#bff3e6', fontSize: 14, cursor: 'pointer',
};

export default function NewVersionStrip() {
  const newVersion = useNewVersion();
  const { callActive, incomingContact, wrapContext } = useContact();
  if (!mayShowStrip({ newVersion, callActive, incomingContact, wrapContext })) return null;
  return (
    <div className="new-version-strip" role="status" style={strip}>
      <span style={{ flex: 1 }}>{STRIP_TEXT}</span>
      <button type="button" style={button} onClick={() => window.location.reload()}>Refresh now</button>
    </div>
  );
}
